import { Unit } from "@/components/Agencies/ReportBuilder/reportUnit";
import { FiltersListPermittedParams } from "@/mixins/http/ReportTemplateMixin";
import { Model, Target } from "@/models";

export default class ReportTemplateCompetitor extends Model {
  static type = "reportTemplateCompetitors";

  competitors!: FiltersListPermittedParams;
  agencies!: FiltersListPermittedParams;
  companies!: FiltersListPermittedParams;
  brands!: FiltersListPermittedParams;
  products!: FiltersListPermittedParams;
  sectors!: FiltersListPermittedParams;
  categories!: FiltersListPermittedParams;
  classes!: FiltersListPermittedParams;
  type!: Unit;
  weekType!: string;
  temporalDetail!: boolean;
  granularity!: string | null;
  quota!: boolean;
  raw!: boolean;
  inclusion!: boolean;
  showSpecialInitiatives!: boolean;
  formatDetail!: boolean;
  showVodDevices!: boolean;
  applyClientDatabase!: boolean;
  attachSectorCategoryClass!: boolean;

  auditelTarget!: number | null;
  grpTarget?: Target | null;

  competitorsNames?: Record<string, string>;
  agenciesNames?: Record<string, string>;

  createdAt!: Date;
  updatedAt!: Date;
}
